package com.gsb.vyapar.bhagya.presentation.business.util
import com.gsb.vyapar.bhagya.domain.Business
import com.gsb.vyapar.bhagya.domain.getLatitude
import com.gsb.vyapar.bhagya.domain.getLongitude
import com.gsb.vyapar.bhagya.presentation.location.util.getSavedLocation
import kotlin.math.asin
import kotlin.math.cos
import kotlin.math.pow
import kotlin.math.sin
import kotlin.math.sqrt
import kotlin.math.PI

fun List<Business>.sortedByDistance(): List<Business> {
    getSavedLocation().let {
        if (it?.latitude == null || it.longitude == null) return this
        return this.sortedBy { business ->
            val bLat = business.getLatitude().toDoubleOrNull()
            val bLon = business.getLongitude().toDoubleOrNull()
            if (bLat != null && bLon != null) {
                haversineDistance(it.latitude, it.longitude, bLat, bLon)
            } else {
                Double.MAX_VALUE
            }
        }
    }
}

private fun haversineDistance(lat1: Double, lon1: Double, lat2: Double, lon2: Double): Double {
    val earthRadius = 6371.0
    val dLat = (lat2 - lat1).toRadians()
    val dLon = (lon2 - lon1).toRadians()
    val a = sin(dLat / 2).pow(2) + cos(lat1.toRadians()) * cos(lat2.toRadians()) * sin(dLon / 2).pow(2)
    val c = 2 * asin(sqrt(a))
    return earthRadius * c
}

private fun Double.toRadians(): Double = this * (PI / 180.0)
